/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the GetUserAccessDto interface.
 */
export function instanceOfGetUserAccessDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('brandId' in value) || value['brandId'] === undefined)
        return false;
    if (!('locationIds' in value) || value['locationIds'] === undefined)
        return false;
    if (!('hasAccess' in value) || value['hasAccess'] === undefined)
        return false;
    return true;
}
export function GetUserAccessDtoFromJSON(json) {
    return GetUserAccessDtoFromJSONTyped(json, false);
}
export function GetUserAccessDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'brandId': json['brandId'],
        'locationIds': json['locationIds'],
        'hasAccess': json['hasAccess'],
    };
}
export function GetUserAccessDtoToJSON(json) {
    return GetUserAccessDtoToJSONTyped(json, false);
}
export function GetUserAccessDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'brandId': value['brandId'],
        'locationIds': value['locationIds'],
        'hasAccess': value['hasAccess'],
    };
}
//# sourceMappingURL=GetUserAccessDto.js.map